import { render, staticRenderFns } from "./ShowDocsPupup.vue?vue&type=template&id=d3690c9e"
import script from "./ShowDocsPupup.vue?vue&type=script&lang=js"
export * from "./ShowDocsPupup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3690c9e')) {
      api.createRecord('d3690c9e', component.options)
    } else {
      api.reload('d3690c9e', component.options)
    }
    module.hot.accept("./ShowDocsPupup.vue?vue&type=template&id=d3690c9e", function () {
      api.rerender('d3690c9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popups/show-docs-popup/ShowDocsPupup.vue"
export default component.exports